document.addEventListener('DOMContentLoaded', function () {
  initDailyCountdowns();
  initStickyBottomBanner();
  initLazyVideos();
});

function initDailyCountdowns() {
  var countdowns = document.querySelectorAll('[data-countdown]');

  if (!countdowns.length) {
    return;
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function getNYMidnightRemainingMs() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    }).formatToParts(new Date());

    var hour = 0;
    var minute = 0;
    var second = 0;

    parts.forEach(function (part) {
      if (part.type === 'hour') hour = parseInt(part.value, 10);
      if (part.type === 'minute') minute = parseInt(part.value, 10);
      if (part.type === 'second') second = parseInt(part.value, 10);
    });

    if (hour === 24) {
      hour = 0;
    }

    var elapsedSeconds = hour * 3600 + minute * 60 + second;
    var remainingSeconds = 86400 - elapsedSeconds;

    if (remainingSeconds <= 0) {
      remainingSeconds = 86400;
    }

    return remainingSeconds * 1000;
  }

  function updateCountdowns() {
    var diff = getNYMidnightRemainingMs();
    var days = 2;
    var hours = Math.floor(diff / (1000 * 60 * 60));
    var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((diff % (1000 * 60)) / 1000);

    countdowns.forEach(function (countdown) {
      var parts = {
        days: countdown.querySelector('[data-part="days"]'),
        hours: countdown.querySelector('[data-part="hours"]'),
        minutes: countdown.querySelector('[data-part="minutes"]'),
        seconds: countdown.querySelector('[data-part="seconds"]')
      };

      if (parts.days) parts.days.textContent = pad(days);
      if (parts.hours) parts.hours.textContent = pad(hours);
      if (parts.minutes) parts.minutes.textContent = pad(minutes);
      if (parts.seconds) parts.seconds.textContent = pad(seconds);
    });
  }

  updateCountdowns();
  setInterval(updateCountdowns, 1000);
}

function initStickyBottomBanner() {
  var page = document.querySelector('.adv-liam-page.has-sticky-bottom');
  var banner = document.getElementById('al-bottom-banner');

  if (!page || !banner) {
    return;
  }

  function measure() {
    page.style.paddingBottom = banner.offsetHeight + 'px';
  }

  measure();
  window.addEventListener('resize', measure);

  if (typeof ResizeObserver !== 'undefined') {
    var observer = new ResizeObserver(measure);
    observer.observe(banner);
  }
}

function initLazyVideos() {
  var videos = document.querySelectorAll('.adv-liam-page .al-device-video[data-src]');
  if (!videos.length) return;

  function activateVideo(video) {
    if (video.dataset.loaded === 'true') return;
    var src = video.getAttribute('data-src');
    if (!src) return;
    video.src = src;
    video.dataset.loaded = 'true';
    if (video.dataset.autoplay === 'true') {
      video.play().catch(function () {});
    }
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          activateVideo(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' });

    videos.forEach(function (video) {
      observer.observe(video);
    });
    return;
  }

  videos.forEach(activateVideo);
}
